import { lazy, Suspense } from "react";
import { LandingPage } from "./landing/LandingPage";
import { ErrorBoundary } from "./landing/components/shared";
import "./index.css";

const WidgetPreviewPage = lazy(() =>
	import("./landing/components/widgets/WidgetPreviewPage").then((m) => ({
		default: m.WidgetPreviewPage,
	})),
);

const ContactSalesPage = lazy(() =>
	import("./landing/components/pages/ContactSalesPage").then((m) => ({
		default: m.ContactSalesPage,
	})),
);

const LegalNoticePage = lazy(() =>
	import("./landing/components/pages/LegalNoticePage").then((m) => ({
		default: m.LegalNoticePage,
	})),
);

const PrivacyPolicyPage = lazy(() =>
	import("./landing/components/pages/PrivacyPolicyPage").then((m) => ({
		default: m.PrivacyPolicyPage,
	})),
);

const CookiesPolicyPage = lazy(() =>
	import("./landing/components/pages/CookiesPolicyPage").then((m) => ({
		default: m.CookiesPolicyPage,
	})),
);

function App() {
	const path = window.location.pathname;

	if (path === "/widgets") {
		return (
			<Suspense fallback={null}>
				<WidgetPreviewPage />
			</Suspense>
		);
	}

	if (path === "/contact") {
		return (
			<Suspense fallback={null}>
				<ContactSalesPage />
			</Suspense>
		);
	}

	if (path === "/legal-advice") {
		return (
			<Suspense fallback={null}>
				<LegalNoticePage />
			</Suspense>
		);
	}

	if (path === "/privacy-policy") {
		return (
			<Suspense fallback={null}>
				<PrivacyPolicyPage />
			</Suspense>
		);
	}

	if (path === "/cookies-policy") {
		return (
			<Suspense fallback={null}>
				<CookiesPolicyPage />
			</Suspense>
		);
	}

	return <LandingPage />;
}

export default function AppWithBoundary() {
	return (
		<ErrorBoundary>
			<App />
		</ErrorBoundary>
	);
}
